import { render } from "./Mobile.vue?vue&type=template&id=6d7d0043&bindings={}"
import script from "./Mobile.vue?vue&type=script&lang=js"
export * from "./Mobile.vue?vue&type=script&lang=js"

import "./Mobile.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script